module.exports = __webpack_public_path__ + "img/icn_value1.44c91abd.svg";